import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import { api } from './createInstance';

export const getJSON = <T = unknown>(
  url: string,
  config?: AxiosRequestConfig<T>
): AxiosResponse['data'] => {
  return api.get<T>(url, config).then(data => data);
};
